<template>

    <!--input type="text" hidden class="js-datepicker-start-date" name="start-date" v-model="this.startDate">
    <input type="text" hidden class="js-datepicker-end-date" name="end-date" v-model="this.endDate"-->

    <div class="datepicker-container datepicker-container-lp" v-bind:class="this.datepickerOpen ? 'show' : ''"
         ref="datepickercontainer">
        <div class="datepicker-dropdown datepicker-dropdown-lp" v-click-outside="(e,ee) => $emit('datepickerfocusout',e,ee,this.datepickerOpen)">
            <!--- TEMPLATENAME: datepicker.isml --->
            <!--div class="datepicker-closing-mobile">
              <div class="back-arrow js-back-arrow">
                <span class="icon icon-long-arrow"></span>
              </div>
              <div class="datepicker-title">
                {{ translations.filter.startdate.label }}
              </div>
            </div-->

            <div class="datepicker-header js-datepicker-header">
                <div class="datepicker-selection-box">
                    <div id="datepicker-selection" class="selection-input">
                        <template v-if="this.startDate && this.endDate">
                            {{ translations.filter.startdate.from }} <strong>{{ this.format(this.startDate, 'DD/MM/YYYY') }}</strong> {{ translations.filter.startdate.to }} <strong>{{ this.format(this.endDate, 'DD/MM/YYYY') }}</strong>
                        </template>
                        <span class="datepicker-placeholder" v-else>
                          {{ translations.filter.startdate.placeholder }}
                        </span>
                    </div>
                    <button type="button" class="reset-datepicker js-reset-datepicker icon icon-cancel"
                            v-bind:class="this.startDate && this.endDate ? 'show' : ''"
                            aria-label="Rimuovi date"
                            v-on:click="this.resetDatepickerButton(true)" ref="datepickerreset"></button>
                </div>
                <div class="datepicker-range-variations">
                    <input class="preset-checkbox" type="radio" name="variation" id="oneday" value="1"
                           v-model="this.rangeVar" v-on:click="this.rangeVariation(1)" hidden/>
                    <label class="preset-label" for="oneday">{{ translations.filter.startdate.rangevar.v1 }}</label>
                    <input class="preset-checkbox" type="radio" name="variation" id="threedays" value="3"
                           v-model="this.rangeVar" v-on:click="this.rangeVariation(3)" hidden/>
                    <label class="preset-label" for="threedays">{{ translations.filter.startdate.rangevar.v3 }}</label>
                    <input class="preset-checkbox" type="radio" name="variation" id="sevendays" value="7"
                           v-model="this.rangeVar" v-on:click="this.rangeVariation(7)" hidden/>
                    <label class="preset-label" for="sevendays">{{ translations.filter.startdate.rangevar.v7 }}</label>
                </div>
            </div>
            <div id="easepick" ref="easepick" class="easypick-vue d-none"></div>

            <div class="datepicker-footer js-datepicker-footer container-lg"
                 v-if="this.datepickerpresetsrange !== undefined || this.datepickerpresetsrange !== null">
                <div class="datepicker-range-presets row">
                    <h4 class="title col-12">{{ translations.filter.startdate.preset.title }}</h4>

                    <button class="preset col-6 js-range-preset"
                            v-bind:class="this.rangePresetVar==rangePreset.name ? 'selected' : ''"
                            v-on:click="this.rangePresetApply(rangePreset.start,rangePreset.end,rangePreset.name)"
                            v-for="(rangePreset, index) in this.datepickerpresetsrange">
                        {{ rangePreset.name }}
                    </button>
                </div>
            </div>
            <button type="button" class="btn btn-secondary datepicker-close-btn d-none d-lg-block" v-on:click="toggleDatepicker()">
                {{ translations.filter.datepicker.closeBtn }}
            </button>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {easepick} from '@easepick/bundle';
import {RangePlugin} from '@easepick/range-plugin';
import {LockPlugin} from '@easepick/lock-plugin';
import {AmpPlugin} from '@easepick/amp-plugin';
import {KbdPlugin} from '@easepick/kbd-plugin';
import { applyDayAria, bindGridBridge } from '../helpers/datepickerA11y.js';

export default {
    data() {
        return {
            startDateFinal: null,
            endDateFinal: null,
            startDate: null,
            endDate: null,
            maxDate: new Date().setDate(new Date().getDate() + 365),
            minDate: new Date().getTime(),
            rangeVar: '0',
            rangePresetVar: 'Personalizzato',//TODO: Attenzione allo stab di 'Personalizzato' (qui e in tutti i posti utilizzato)
            datepicker: null,
            datepickerOpen: false,
            isMobile: window.innerWidth <= 768
        }
    },
    props: {
        opened: Boolean
    },
    computed: {
        ...mapState([
            'datepickerpresetsrange',
            'datepickercssurl',
            'translations',
            'breakpoints'
        ]),
    },
    methods: {
        ...mapActions([
            'setApplyFilter'
        ]),
        init() {
            var calendarsgridnumber = this.breakpoints.sm ? 1 : this.breakpoints.lg ? 2 : 1;

            this.datepicker = new easepick.create({
                element: this.$refs.easepick,
                css: [
                    this.datepickercssurl
                ],
                lang: 'it-IT',
                format: 'YYYY-MM-DDTHH:mm:ss.sssZ',
                grid: calendarsgridnumber,
                calendars: calendarsgridnumber,
                zIndex: 20,
                inline: true,
                setup(picker) {
                    picker.on('render', () => {
                        const el = picker.options.element;

                        if (el && el.classList.contains('easypick-vue')) {
                            const localWrappers = $(el).siblings('.easepick-wrapper');

                            if (localWrappers.length > 1 && !this.isMobile) {
                                localWrappers.first().remove();
                            }

                            const ui = picker.ui;
                            if (ui && ui.shadowRoot) {
                                const container = ui.shadowRoot.querySelector('.container');
                                if (container) {
                                    $(container).addClass('datepicker').addClass('datepicker-lp');
                                    applyDayAria(container);
                                    bindGridBridge(picker);
                                }
                            }
                        }
                    });
                },
                plugins: [RangePlugin, LockPlugin, AmpPlugin, KbdPlugin],
                RangePlugin: {
                    tooltip: false,
                    startDate: this.startDate,
                    endDate: this.endDate
                },
                LockPlugin: {
                    minDate: this.minDate,
                    maxDate: this.maxDate
                },
                AmpPlugin: {
                    darkMode: false
                },
                KbdPlugin: {
                    unitIndex: 0,
                    dayIndex: -1,
                    html: '<span></span>'
                }
            });

            this.datepicker.on('select', e => {
                var startDate = e.detail.start;
                var endDate = e.detail.end;
                var startDateTimestamp = new Date(startDate).getTime();
                var endDateTimestamp = new Date(endDate).getTime();
                //console.log(this.$refs.datepickerreset);
                //this.$refs.datepickerreset.classList.add('show');

                this.startDate = startDateTimestamp;
                this.endDate = endDateTimestamp;
                this.rangeVar = '0';
                this.rangePresetVar = 'Personalizzato';
            });

            /*if(this.opened){
              this.datepickerOpen = true;
            }*/
        },
        toggleDatepicker() {
            this.datepickerOpen = !this.datepickerOpen;
            if (this.datepickerOpen) {
                this.datepicker.show();
            } else {
                this.savedateDatepicker();
                this.datepicker.hide();
            }
        },
        savedateDatepicker() {
            if ((this.startDate && this.startDate != this.startDateFinal) || (this.endDate && this.endDate != this.endDateFinal)) {
                this.startDateFinal = this.startDate;
                this.endDateFinal = this.endDate;
                this.applyFilter('date', {
                    data_da: this.format(this.startDateFinal, 'YYYY-MM-DD'),
                    data_a: this.format(this.endDateFinal, 'YYYY-MM-DD')
                }, 'filter');
                this.$emit('datefinal', this.format(this.startDateFinal, 'DD/MM/YYYY'), this.format(this.endDateFinal, 'DD/MM/YYYY'));
            }
        },
        resetDatepicker(final) {
            this.datepicker.clear();
            this.datepicker.gotoDate(new Date().getTime());
            this.startDate = null;
            this.endDate = null;
            this.rangePresetVar = 'Personalizzato';

            this.rangeVar = '0';

            if (final) {
                this.startDateFinal = null;
                this.endDateFinal = null;
                this.$emit('datefinal', this.format(this.startDateFinal, 'DD/MM/YYYY'), this.format(this.endDateFinal, 'DD/MM/YYYY'));
            }
        },
        resetDatepickerButton(final) {
            if (this.startDateFinal && this.endDateFinal) {
                this.applyFilter('date', {
                    data_da: this.format(this.startDateFinal, 'YYYY-MM-DD'),
                    data_a: this.format(this.endDateFinal, 'YYYY-MM-DD')
                }, 'filter');
            }
            this.resetDatepicker(final);
        },
        rangePresetApply(presetStart, presetEnd, presetName) {
            if (presetStart && presetEnd) {
                this.startDate = parseInt(presetStart);
                this.endDate = parseInt(presetEnd);
                this.datepicker.setStartDate(presetStart);
                this.datepicker.setEndDate(presetEnd);
                this.datepicker.gotoDate(presetStart);
            } else {
                this.datepicker.clear();
                this.startDate = null;
                this.endDate = null;
            }
            this.rangeVar = '0';
            this.rangePresetVar = presetName;
        },
        rangeVariation(rangev) {
            var newdateStart = new Date(this.startDate);
            var newdateEnd = new Date(this.endDate);
            if (rangev == parseInt(this.rangeVar)) {
                if (this.startDate && this.endDate) {
                    //console.log('uguali');
                    newdateStart.setDate(newdateStart.getDate() + parseInt(rangev));
                    newdateEnd.setDate(newdateEnd.getDate() - parseInt(rangev));
                }
                this.rangeVar = 0;
            } else {
                if (this.startDate && this.endDate) {
                    newdateStart.setDate(newdateStart.getDate() - parseInt(rangev) + parseInt(this.rangeVar));
                    newdateEnd.setDate(newdateEnd.getDate() + parseInt(rangev) - parseInt(this.rangeVar));
                }
            }
            this.startDate = newdateStart.getTime();
            this.endDate = newdateEnd.getTime();
            this.datepicker.setStartDate(this.startDate);
            this.datepicker.setEndDate(this.endDate);
        },
        applyFilter(name, value, type) {
            if (!this.breakpoints.lg) {
                this.setApplyFilter([name, value, type]);
            } else {
                this.setApplyFilter([name, value, type, true]);
            }
        },
        format(date, type) {
            if (date) {
                var separator = type.indexOf('/') > -1 ? '/' : '-';
                var h = type.split(separator);
                var date = new Date(date);
                var dateString = '';

                for (var i = 0; i < h.length; i++) {
                    if (h[i] == 'YYYY') {
                        dateString += date.getFullYear().toString();
                    } else if (h[i] == 'MM') {
                        dateString += ("0" + (date.getMonth() + 1)).slice(-2).toString();
                    } else if (h[i] == 'DD') {
                        dateString += ("0" + date.getDate()).slice(-2).toString();
                    }
                    dateString += separator;
                }
                return dateString.slice(0, dateString.length - 1);
            }
            return '';
        },
        setDateFromExt(labelDate, date) {
            var h = date.split("-");
            var dateStamp = new Date(Date.UTC(h[0], h[1] - 1, h[2])).getTime();
            if (labelDate == 'data_da') {
                this.startDate = dateStamp;
                this.datepicker.setStartDate(this.startDate);
                this.startDateFinal = this.startDate;
                this.datepicker.gotoDate(this.startDate);
                return this.format(this.startDateFinal, 'DD/MM/YYYY');
            } else {
                this.endDate = dateStamp;
                this.datepicker.setEndDate(this.endDate);
                this.endDateFinal = this.endDate;
                return this.format(this.endDateFinal, 'DD/MM/YYYY');
            }
        }
    },
    mounted() {
        this.init();
    }
}
</script>
